module.exports = __webpack_public_path__ + "img/totalActive.c9521878.png";